import React from 'react';
import { styled } from '@mui/material';
import Dialog, { DialogProps } from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Slide from '@mui/material/Slide';
import { TransitionProps } from '@mui/material/transitions';

export type CustomDialogProps = {
  title?: React.ReactNode;
  content?: React.ReactNode;
  actions?: React.ReactNode;
};

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    children: React.ReactElement<any, any>;
  },
  ref: React.Ref<unknown>,
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export const SlideDialog: React.FC<
  CustomDialogProps & DialogProps & { $height: number }
> = ({ title, content, actions, children, ...dialogProps }) => {
  const { $height: _, ...filteredProps } = dialogProps;

  return (
    <Dialog {...filteredProps} TransitionComponent={Transition} keepMounted>
      {title && <DialogTitle>{title}</DialogTitle>}
      {content && <DialogContent>{content}</DialogContent>}
      {actions && <DialogActions>{actions}</DialogActions>}
      {children}
    </Dialog>
  );
};

export const FullHeightSlideDialog = styled(SlideDialog)(
  ({ $height }: { $height: number }) => ({
    '& .MuiDialog-container': {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'flex-end',
    },
    '& .MuiPaper-root': {
      borderTopLeftRadius: '24px',
      borderTopRightRadius: '24px',
      borderBottomLeftRadius: 0,
      borderBottomRightRadius: 0,
      maxWidth: '1024px',
      height: `calc(100dvh - ${$height}px)`,
      width: '100%',
      padding: 0,
      margin: 0,
      boxShadow: '0px 0px 24px 4px #121C2D33',
      bottom: 0,
      position: 'relative',
    },
  }),
);
